import { MenuItem as MuiMenuItem } from '@mui/material';
export const MenuItem = MuiMenuItem;
